"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidSortHelpers = void 0;
const date_fns_1 = require("date-fns");
const enums_1 = require("../structs/enums");
const array_helpers_1 = require("./array.helpers");
const date_helpers_1 = require("./date.helpers");
const object_helpers_1 = require("./object.helpers");
function sortByDate(dataItems, dataPath, order = enums_1.FluidSortOrder.ASC) {
    if (!date_helpers_1.FluidDateHelpers.canCastAllEntriesToDate(dataItems, dataPath)) {
        console.debug('[FLUID] Not all entries can be cast to date. Sorting by date for those that can, and appending alpha sort.');
        const dates = dataItems.filter(dataItem => date_helpers_1.FluidDateHelpers.canBeCastToDate((0, object_helpers_1.getAtPath)(dataItem, dataPath)));
        const nonDates = (0, array_helpers_1.sortAlpha)(dataItems.filter(dataItem => !date_helpers_1.FluidDateHelpers.canBeCastToDate((0, object_helpers_1.getAtPath)(dataItem, dataPath))), dataPath);
        return [
            ...sortByDate(dates, dataPath, order),
            ...(order === enums_1.FluidSortOrder.ASC ? nonDates : nonDates.reverse())
        ];
    }
    return dataItems.sort((a, b) => compareDates((0, object_helpers_1.getAtPath)(a, dataPath), (0, object_helpers_1.getAtPath)(b, dataPath), order));
}
function compareDates(dateOne, dateTwo, order) {
    const dateOneFinal = date_helpers_1.FluidDateHelpers.isDate(dateOne) ? dateOne : new Date(dateOne);
    const dateTwoFinal = date_helpers_1.FluidDateHelpers.isDate(dateTwo) ? dateTwo : new Date(dateTwo);
    return order === enums_1.FluidSortOrder.ASC ? (0, date_fns_1.compareAsc)(dateOneFinal, dateTwoFinal) : (0, date_fns_1.compareDesc)(dateOneFinal, dateTwoFinal);
}
exports.FluidSortHelpers = {
    sortByDate
};
